// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trich_sidebar i{vertical-align:middle}@media screen and (min-width: 600px){.sidenav---expanded---1KdUL ~ #page_content{margin-left:240px;transition:0.5s}.sidenav---collapsed---LQDEv ~ #page_content{margin-left:64px;transition:0.5s}}@media screen and (max-width: 599px){.sidenav---collapsed---LQDEv{background-color:transparent !important}.sidenav---collapsed---LQDEv .sidenav---sidenav-nav---3tvij{display:none}}\n", ""]);
// Exports
module.exports = exports;
